<template>
  <v-app>
    <v-container class="mt-16">
      <v-row justify="center">
        <v-card class="pa-16">
          <v-card-body>
            <v-row justify="center">
              <v-col class="mb-16">
                <!-- <h1>{{ asuulgaId }}</h1> -->
                <h3>Xайx өгөгдлөө оруулна уу</h3>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  label="Xайx үгээ энд бичээд ENTER дарна уу."
                  prepend-icon="mdi-magnify"
                  @keydown.enter="_search()"
                  v-model="searchValue"
                >
                  <template v-slot:prepend>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on"> mdi-magnify </v-icon>
                      </template>
                      I'm a tooltip
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col v-if="users != null && users.length > 0" cols="12" md="6">
                <v-card style="width: 100%" class="pa-16">
                  <p>{{ users[0].lastName }}</p>
                  <p>{{ users[0].firstName }}</p>
                  <p class="font-weight-bold">{{ users[0].email }}</p>
                  <p>{{ users[0].phone }}</p>
                  <v-btn color="secondary" @click="_select(users[0])">
                    Сонгоx
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
          </v-card-body>
        </v-card>
      </v-row>
    </v-container>
    <v-snackbar top v-model="snackbar" color="error">
      Мэдээлэл олдсонгүй
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          xааx
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
// Utilities
import { get } from "vuex-pathify";
import Vue from "vue";
const fb = require("../firebaseConfig.js");

export default {
  name: "AsuulgaSearch",

  data: () => ({
    snackbar: false,
    searchValue: null,
    subtitle:
      '<i class="mdi mdi-arrow-up green--text"></i><span class="green--text">55%</span>&nbsp;increase in today\'s sales',
    time: "updated 4 minutes ago",
    users: [],
  }),
  computed: {},
  created() {},
  props: {
    asuulgaId: {
      type: String,
      required: true,
    },
  },
  methods: {
    _select(uuser) {
      console.log(uuser);
      this.$router.push({
        name: "AsuulgaDetail",
        params: { asuulgaId: this.asuulgaId, uuser: uuser },
      });
    },
    async _search() {
      console.log(this.searchValue);
      if (this.searchValue && this.searchValue != "")
        this._searchUser(this.searchValue.trim().toLowerCase());
    },
    async _searchUser(searchValue) {
      //if (this.searchField == "register" || this.searchField == "code")
      //if (value && value != "") value = value.toLowerCase();
      console.log(searchValue);
      this.loading = true;
      var query = fb.db.collection("users").where("email", "==", searchValue);

      if (query != null) {
        var documentSnapshots = await query.get();
        this.users = [];
        documentSnapshots.forEach((doc) => {
          let object = doc.data();
          object.id = doc.id;
          object.ref = doc.ref;
          this.users.push(object);
        });

        if (this.users && this.users.length == 0) this.snackbar = true;
      }
      this.loading = false;
    },
    _goDetail(asuulga) {
      console.log("dddd");
      this.$router.push({
        name: "AsuulgaDetail",
        params: { asuulgaId: asuulga.id },
      });
    },
  },
};
</script>
<style>
#newelement {
  border-color: red;
}
</style>